// Styles
import { useStyles } from './styles/ChipCell.styles';

// Types
import type { IdMap } from '@api/org';
import type { User } from '@features/redux/apis/auth';

export const Chips = ({ values }: { values: string[] }) => {
    const classes = useStyles();

    return (
        <div className={classes.chipWrapper}>
            {values?.length ? (
                values.map((value, idx) => (
                    <span key={`chip-${idx}`} className={classes.chip}>
                        {value}
                    </span>
                ))
            ) : (
                <>-</>
            )}
        </div>
    );
};

export const chipCell =
    (key: keyof Pick<User, 'custom:Companies' | 'custom:Resellers' | 'custom:Locations'>, idMap: IdMap) =>
    ({ row }: { row: User }) => {
        const all = row[key][0] === '*';

        const values = all
            ? ['All']
            : row[key]?.length >= 1
            ? row[key].split(',').map((id) => idMap[id] || 'Error: Could Not Find')
            : ['Error: Could Not Find'];

        return <Chips values={values} />;
    };
